module.exports = __webpack_public_path__ + "img/image_2022_07_25T09_12_19_321Z.42c45b10.png";